import styled from 'styled-components';
import { useExternalMedia } from '../../hooks/useExternalMedia';
import { Col } from "react-bootstrap";




const Left = () => {


  const {
    businessPageImage
  } = useExternalMedia();


  return (
    <>
      <Col
        xs={{ span: 12, order: 1 }}
        md={{ span: 6, order: 1 }}
        lg={{ span: 6, order: 1 }}
        style={{
          padding: "0",
        }}
        className="d-none d-lg-block"
      >
        <Img src={businessPageImage} alt="eratek-1kb" />
      </Col>

    </>
  );
}


export default Left;



const Img = styled.img`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 100%;
  max-height: 100vh;
  min-width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 10;
`;
